const Register = () => import('@/components/business/Register')
const Getstarted = () => import('@/components/business/Register1')
// const Impact = () => import('@/components/business/Impact')
const GivingStories = () => import('@/components/business/giving-story/list')
const CreateGivingStory = () => import('@/components/business/giving-story/create')
const EditGivingStory = () => import('@/components/business/giving-story/edit')
const PaymentSuccess = () => import('@/components/business/giving-cart/PaymentSuccess')

const FamilyDashboard = () => import('@/components/business/Family-v1')
const FamilyDashboard1 = () => import('@/components/business/Family')
const AllProject = () => import('@/components/business/AllProject')
const FamilyProfile = () => import('@/components/business/FamilyProfile')
const Project = () => import('@/components/business/Project')
const ProjectUpdates = () => import('@/components/business/updates/ProjectUpdates')
const ProjectUpdateDetails = () => import('@/components/business/updates/ProjectUpdateDetails')
const PublicPartnersProfile = () => import('@/components/business/profile/Partner')
const FamilyDetails = () => import('@/components/business/FamilyDetails')
const Invite = () => import('@/components/business/connect/Invite')
const ImpactReminders = () => import('@/components/business/ImpactReminders')
const BillingToken = () => import('@/components/business/Billing/token')
const BillingTokenMobile = () => import('@/components/business/Billing/billing-token-mobile')
const PurchaseToken = () => import('@/components/business/Billing/purchase-token')
const UpgradeMembership = () => import('@/components/business/Billing/upgrade-membership')
const TokenManagement = () => import('@/components/business/TokenManagement')
const BundleProject = () => import('@/components/business/BundleProject')
const EmailVerify = () => import('@/components/EmailVerify')
const ProfileUpgrade = () => import('@/components/business/profile/Upgrade')
const ResetPassword = () => import('@/components/business/ResetPassword')

export default [
  {
    path: '/register',
    name: 'public-join-business',
    components: {
      business: Register
    },
    meta: (route) => ({title: 'Member Registration'})
  },
  {
    path: '/get-started',
    name: 'get-started',
    components: {
      business: Getstarted
    },
    meta: (route) => ({title: 'Member Registration'})
  },
  {
    path: '/verify-email/:key',
    name: 'verify-email',
    components: {
      widgets: EmailVerify
    },
    meta: (route) => ({title: 'Verify Email'})
  },
  {
    // The route just needs to exist with a name containing 'forgot-password' —
    // App.vue conditionally renders the ForgotPassword component based on the
    // route name (see forgotPasswordRoute() in App.vue), not via <router-view>.
    path: '/forgot-password/:key',
    name: 'forgot-password',
    meta: (route) => ({title: 'Forgot Password'})
  },
  {
    path: '/projectdetail/:id',
    name: 'projectdetail',
    components: {
      business: Project
    }
  },
  {
    path: '/bundledetail/:id',
    name: 'bundledetail',
    components: {
      business: BundleProject
    }
  },
  {
    path: '/project-updates/details/:id',
    name: 'project-updates.details',
    components: {
      business: ProjectUpdateDetails
    }
  },
  {
    path: '/project-updates/list',
    name: 'project-updates.list',
    components: {
      business: ProjectUpdates
    },
    meta: (route) => ({title: 'Worthy Causes and Project Updates'})
  },
  {
    path: '/wcu_partner/:id',
    name: 'wcuprofile',
    components: {
      business: PublicPartnersProfile
    }
  },
  { // new 3d working scenario .
    path: '/recurring-impacts',
    name: 'giving-stories',
    components: {
      business: GivingStories
    },
    meta: (route) => ({title: 'Giving Moments'})
  },
  {
    path: '/billing-tokens',
    name: 'billing-tokens',
    components: {
      business: BillingToken
    },
    meta: (route) => ({title: 'Token Billing Details'})
  },
  {
    path: '/purchase-token',
    name: 'purchase-token',
    components: {
      business: PurchaseToken
    },
    meta: (route) => ({title: 'Token Billing Details', layout: 'blank'})
  },
  {
    path: '/billing-token-mobile',
    name: 'billing-token-mobile',
    components: {
      business: BillingTokenMobile
    },
    meta: (route) => ({title: 'Tokens and Billing', layout: 'blank'})
  },
  {
    path: '/upgrade-membership',
    name: 'upgrade-membership',
    components: {
      business: UpgradeMembership
    },
    meta: (route) => ({title: 'Upgrade Your Membership', layout: 'blank'})
  },
  {
    path: '/profile/upgrade-membership',
    name: 'profile-upgrade-membership',
    components: {
      business: UpgradeMembership
    },
    meta: (route) => ({title: 'Upgrade Your Membership', layout: 'blank'})
  },
  {
    path: '/token-management/',
    name: 'token-management',
    components: {
      business: TokenManagement
    },
    meta: (route) => ({title: 'Token Management'})
  },
  {
    path: '/create-recurring-impacts',
    name: 'create-recurring-impacts',
    components: {
      business: CreateGivingStory
    },
    meta: (route) => ({title: 'Create Giving Moments'})
  },
  { // new 3d working scenario.
    path: '/recurring-impact/:id',
    name: 'edit-recurring-impact',
    components: {
      business: EditGivingStory
    },
    meta: (route) => ({title: 'Editing Giving Moments'})
  },
  {
    path: '/family-profile',
    name: 'family-profile',
    components: {
      business: FamilyProfile
    },
    meta: (route) => ({title: 'Family Profile'})
  },
  {
    path: '/view-all-projects',
    name: 'view-all-projects',
    components: {
      business: AllProject
    },
    meta: (route) => ({title: 'Projects'})
  },
  {
    path: '/payment-success/',
    name: 'payment.success',
    components: {
      business: PaymentSuccess
    },
    meta: (route) => ({title: 'Impact Cart'})
  },
  {
    path: '/',
    name: 'family-dashbord',
    components: {
      business: FamilyDashboard
    },
    meta: (route) => ({title: 'Home'})
  },
  {
    path: '/impact',
    name: 'impact',
    components: {
      business: FamilyDashboard
    },
    meta: (route) => ({title: 'Home'})
  },
  {
    path: '/impact-v1',
    name: 'impact-v1',
    components: {
      business: FamilyDashboard1
    },
    meta: (route) => ({title: 'Home'})
  },
  {
    path: '/impact-reminders',
    name: 'impact-reminders',
    components: {
      business: ImpactReminders
    },
    meta: (route) => ({title: 'Impact Reminders'})
  },
  {
    path: '/family-details/:id',
    name: 'family-details',
    components: {
      business: FamilyDetails
    },
    meta: (route) => ({title: 'Profile Details'})
  },
  {
    path: '/invite',
    name: 'invite',
    components: {
      business: Invite
    },
    meta: (route) => ({title: 'Invite'})
  },
  {
    path: '/billing-tokens',
    name: 'billing-tokens',
    components: {
      business: BillingToken
    },
    meta: (route) => ({title: 'Token Billing Details'})
  },
  { // new 3d working scenario.
    path: '/profile/upgrade/',
    name: 'profile.upgrade',
    components: {
      business: ProfileUpgrade
    },
    meta: (route) => ({title: 'Upgrade/Renew Membership'})
  },
  {
    path: '/personal/reset-password',
    name: 'business.personal.reset-password',
    components: {
      business: ResetPassword
    },
    meta: (route) => ({title: 'Reset Password'})
  }
]



// WEBPACK FOOTER //
// ./src/router/business.js